<div class="row">
  <div class="col-3" style="display: flex; align-items: center">
    <a class="home-link" routerLink="/home" aria-label="Home" title="Home">
      <img src="assets/img/home.png" alt="" />
    </a>
  </div>
  <div class="col-6 text-center">
    <img class="hallmark" src="../../assets/img/chevron-logo.png" alt="Chevron Logo" />
    <h1>
      <a class="lh-base light-blue hide-underline birds_name">Capacity and Flow Network System of Record</a>
    </h1>
  </div>
  <div class="col-3 text-end align-items-center justify-content-end" style="display: flex">
    <img alt="profile" style="height: 50px; padding: 5px" src="../../assets/img/cvx_people_03_RGB.png" />
    <div class="abu_ent">
      welcome,
      <br />
      {{ firstName }} {{ lastName }}
    </div>

    <ng-template #loginBlock>
      <div class="login-container"></div>
    </ng-template>
  </div>
</div>